import React from 'react'
import { GridColumn as Column, Grid } from '@progress/kendo-react-grid'
import { VerifiableActionDto } from 'api/Leads/Types/VerifiableActionDto'
import { formatLocalDateUTC } from 'utils/date'

interface Props {
  leadVerifiableActions: VerifiableActionDto[]
}

export const LeadVerificationsTable: React.FC<Props> = ({ leadVerifiableActions }) => {
  return (
    <Grid
      style={{ margin: '2.5rem' }}
      total={leadVerifiableActions.length}
      data={leadVerifiableActions}
      resizable
    >
      <Column title='Type' field='verifiableActionType.name' className='table-columns__content' />
      <Column
        title='Sent Date'
        field='created'
        cell={(gridCellProps) => (
          <td>{formatLocalDateUTC(gridCellProps.dataItem.created, true)}</td>
        )}
        className='table-columns__content'
      />
      <Column
        title='Expiry Date'
        field='expiryAt'
        cell={(gridCellProps) => (
          <td>{formatLocalDateUTC(gridCellProps.dataItem.expiryAt, true)}</td>
        )}
        className='table-columns__content'
      />
      <Column
        title='Completion Date'
        field='completedAt'
        cell={(gridCellProps) => (
          <td>{formatLocalDateUTC(gridCellProps.dataItem.completedAt, true)}</td>
        )}
        className='table-columns__content'
      />
    </Grid>
  )
}
